import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  RadarController,
  RadialLinearScale,
  Title,
  Tooltip,
} from "chart.js";

// Define the custom plugin
const centerTextPlugin = {
  id: "centerText",
  beforeDraw(chart) {
    const { width, height, ctx } = chart;
    const options = chart.config.options.plugins.centerText || {};
    const number = options.number || ""; // Number (e.g., total residents)
    const label = options.label || ""; // Label text (e.g., "Residents")

    ctx.save();

    // Draw the number (big and bold)
    ctx.font = "bold 24px Arial"; // Customize the font size and weight
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = options.numberColor || "#000"; // Customize text color
    ctx.fillText(number, width / 2, height / 2 - 10); // Slightly above the center

    // Draw the label (smaller, just under the number)
    ctx.font = "16px Arial"; // Smaller font size
    ctx.fillStyle = options.labelColor || "#666"; // Customize text color
    ctx.fillText(label, width / 2, height / 2 + 20); // Slightly below the center

    ctx.restore();
  },
};

export default defineNuxtPlugin(() => {
  Chart.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    RadarController,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Title,
    Tooltip,
    Legend,
    centerTextPlugin,
  );
});
